import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageSchoolHero2 = ({ children, className }) => {
  const data = useStaticQuery(graphql`
    query {
      desktopImage: file(
        relativePath: { eq: "schools/AdobeStock_392868384_orig.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      className={className}
      image={getImage(data.desktopImage)}
      style={{
        width: "100%",
        height: "100%",
      }}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "right top",
      }}
    >
      {children}
    </GatsbyImage>
  )
}

export default ImageSchoolHero2
